import { Injectable } from '@angular/core';
import { HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
//
// Library Model/Services
//
import { Response } from '../../../../lib/angular/model/common/response';
import { FeatureConfig } from '../../../../lib/angular/model/dealer/feature-config';
import { RtiHttpService } from '../../../../lib/angular/service/rti-HttpService';

//
// App Service(s)
//
import { RtiJsonService } from '../../../../lib/angular/service/common/rti-JsonService';
import { ddHttpService } from '../dd-HttpService';
import * as Library from '../../../../lib/core/library';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';

@Injectable()
export class DDFeatureConfigService extends ddHttpService {
  //
  // Rest API Endpoint
  //
  static readonly GET_API: string = 'feature-config/customer/dealerCode/dealer-features';

  /**
   * getByCode()
   */
  public get(dealerCode: string, params: object): Observable<Response<FeatureConfig[]>> {
    let headers = new HttpHeaders();
    headers = headers.set(this._environment.RTI_X_API_KEY, this._environment.RTI_X_API_VALUE);
    const url = Library.replaceKeyValueWithString(`${DDFeatureConfigService.GET_API}`, {dealerCode});
    return super._get<FeatureConfig>(url, this._map, params, headers);
  }

  /**
   * _map()
   */
  private _map(item: any): FeatureConfig {
    return new FeatureConfig(item);
  }

  /**
   * Function: constructor()
   */
  constructor(http: RtiHttpService,
              private _environment: EnvironmentConfiguration,
              private _jsonService: RtiJsonService) {
    super(http, _environment);
  }
}
